/* eslint-disable  @typescript-eslint/no-explicit-any, camelcase */
/* Generated types. Do not edit by hand */

import { gql } from '@apollo/client'
import * as Apollo from '@apollo/client'
import * as Types from '../../../graphql.generated'

const defaultOptions = {} as const
export type CreateCoachMutationVariables = Types.Exact<{
  email: Types.Scalars['String']['input']
}>

export type CreateCoachMutation = {
  __typename?: 'Mutation'
  createCoach: { __typename?: 'CoachProfile'; id: string; email: string }
}

export type DeleteCoachMutationVariables = Types.Exact<{
  coachID: Types.Scalars['ID']['input']
}>

export type DeleteCoachMutation = {
  __typename?: 'Mutation'
  deleteCoach?: { __typename?: 'CoachProfile'; id: string; email: string } | null
}

export type UpdateCoachEmailMutationVariables = Types.Exact<{
  coachID: Types.Scalars['ID']['input']
  email: Types.Scalars['String']['input']
}>

export type UpdateCoachEmailMutation = {
  __typename?: 'Mutation'
  updateCoachEmail: { __typename?: 'CoachProfile'; id: string; email: string }
}

export const CreateCoachDocument = gql`
  mutation createCoach($email: String!) {
    createCoach(email: $email) {
      id
      email
    }
  }
`
export type CreateCoachMutationFn = Apollo.MutationFunction<CreateCoachMutation, CreateCoachMutationVariables>

/**
 * __useCreateCoachMutation__
 *
 * To run a mutation, you first call `useCreateCoachMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCoachMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCoachMutation, { data, loading, error }] = useCreateCoachMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useCreateCoachMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateCoachMutation, CreateCoachMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CreateCoachMutation, CreateCoachMutationVariables>(CreateCoachDocument, options)
}
export type CreateCoachMutationHookResult = ReturnType<typeof useCreateCoachMutation>
export type CreateCoachMutationResult = Apollo.MutationResult<CreateCoachMutation>
export type CreateCoachMutationOptions = Apollo.BaseMutationOptions<CreateCoachMutation, CreateCoachMutationVariables>
export const DeleteCoachDocument = gql`
  mutation deleteCoach($coachID: ID!) {
    deleteCoach(coachID: $coachID) {
      id
      email
    }
  }
`
export type DeleteCoachMutationFn = Apollo.MutationFunction<DeleteCoachMutation, DeleteCoachMutationVariables>

/**
 * __useDeleteCoachMutation__
 *
 * To run a mutation, you first call `useDeleteCoachMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCoachMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCoachMutation, { data, loading, error }] = useDeleteCoachMutation({
 *   variables: {
 *      coachID: // value for 'coachID'
 *   },
 * });
 */
export function useDeleteCoachMutation(
  baseOptions?: Apollo.MutationHookOptions<DeleteCoachMutation, DeleteCoachMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<DeleteCoachMutation, DeleteCoachMutationVariables>(DeleteCoachDocument, options)
}
export type DeleteCoachMutationHookResult = ReturnType<typeof useDeleteCoachMutation>
export type DeleteCoachMutationResult = Apollo.MutationResult<DeleteCoachMutation>
export type DeleteCoachMutationOptions = Apollo.BaseMutationOptions<DeleteCoachMutation, DeleteCoachMutationVariables>
export const UpdateCoachEmailDocument = gql`
  mutation updateCoachEmail($coachID: ID!, $email: String!) {
    updateCoachEmail(coachID: $coachID, email: $email) {
      id
      email
    }
  }
`
export type UpdateCoachEmailMutationFn = Apollo.MutationFunction<
  UpdateCoachEmailMutation,
  UpdateCoachEmailMutationVariables
>

/**
 * __useUpdateCoachEmailMutation__
 *
 * To run a mutation, you first call `useUpdateCoachEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCoachEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCoachEmailMutation, { data, loading, error }] = useUpdateCoachEmailMutation({
 *   variables: {
 *      coachID: // value for 'coachID'
 *      email: // value for 'email'
 *   },
 * });
 */
export function useUpdateCoachEmailMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateCoachEmailMutation, UpdateCoachEmailMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UpdateCoachEmailMutation, UpdateCoachEmailMutationVariables>(
    UpdateCoachEmailDocument,
    options
  )
}
export type UpdateCoachEmailMutationHookResult = ReturnType<typeof useUpdateCoachEmailMutation>
export type UpdateCoachEmailMutationResult = Apollo.MutationResult<UpdateCoachEmailMutation>
export type UpdateCoachEmailMutationOptions = Apollo.BaseMutationOptions<
  UpdateCoachEmailMutation,
  UpdateCoachEmailMutationVariables
>
